'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Button = require('components/Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _propTypes3 = require('utils/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./StatisticsInfoLine.scss');

var StatisticsInfoLine = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsInfoLine, _PureComponent);

  function StatisticsInfoLine() {
    (0, _classCallCheck3.default)(this, StatisticsInfoLine);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsInfoLine.__proto__ || (0, _getPrototypeOf2.default)(StatisticsInfoLine)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsInfoLine, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          title = _props.title;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          title
        ),
        _react2.default.createElement(
          _Button2.default,
          {
            className: (0, _bind2.default)('btn-primary btn-stroke small squared', styles.changeLink),
            onClick: onChange
          },
          t('Change')
        )
      );
    }
  }]);
  return StatisticsInfoLine;
}(_react.PureComponent), _class.propTypes = {
  onChange: _propTypes2.default.func,
  title: _propTypes3.node
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onChange: _noop3.default
}, _temp);
exports.default = StatisticsInfoLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsInfoLine/StatisticsInfoLine.js
// module id = 849
// module chunks = 1